// util/itemRarityColors.js
import itemTypeToEmoji from 'util/itemTypeToEmoji';

const calculateElusiveTooltip = (item) => {
    if (!item) {
        return 'unknown';
    }
    return `Chance to find next: ${(1 / (10 * (1 + item.getMarketQuantity()))).toFixed(3)}%`;
};
const itemRarityColors = (item, rarityIndex) => {
    let rarity;
    if (item) {
        rarity = itemTypeToEmoji.getRarity(item.itemType);
    } else {
        switch (rarityIndex) {
            case 1:
                rarity = 'LETTER';
                break;
            case 2:
                rarity = 'UNCOMMON';
                break;
            case 3:
                rarity = 'RARE';
                break;
            case 4:
                rarity = 'EPIC';
                break;
            case 5:
                rarity = 'ELUSIVE';
                break;
            default:
                throw new Error(`Unknown rarity index: ${rarityIndex}`);
        }
    }
    switch (rarity) {
        case 'LETTER':
            return {
                textColor: 'rgb(94,94,94)',
                backgroundColor: 'rgb(243,243,246)',
                tooltip: 'Chances to find: 80%',
                actionButtonColor: 'rgb(207,207,207)',
            };
        case 'UNCOMMON':
            return {
                textColor: 'rgb(0,202,255)',
                backgroundColor: 'rgb(240,252,255)',
                tooltip: 'Chances to find: 20%',
                actionButtonColor: 'rgb(0,202,255)',
            };
        case 'RARE':
            return {
                textColor: 'rgb(0,136,255)',
                backgroundColor: 'rgb(227,242,255)',
                tooltip: 'Chances to find: 5%',
                actionButtonColor: 'rgb(0,136,255)',
            };
        case 'EPIC':
            return {
                textColor: 'rgb(134,0,255)',
                backgroundColor: 'rgb(245,233,255)',
                tooltip: 'Chances to find: 0.8%',
                actionButtonColor: 'rgb(134,0,255)',
            };
        case 'ELUSIVE':
            return {
                textColor: 'rgb(255,115,0)',
                backgroundColor: 'rgb(255,237,223)',
                tooltip: calculateElusiveTooltip(item),
                actionButtonColor: 'YELLOW',
            };
        default:
            throw new Error(`Unknown rarity: ${rarity}`);
    }
};

export default itemRarityColors;
